import { SettlementTemplateEmailName } from 'api/endpoints/settlementEmailTemplates';
import { assertSwitchValueNotEmpty } from 'utils/debugUtils';
import './SettlementEmailRecipientDescription.css';

interface Props {
  name: SettlementTemplateEmailName;
}

export const SettlementEmailRecipientDescription = ({ name }: Props) => {
  return (
    <div className="settlement-email-recipient-description">
      <DescriptionContent name={name} />
    </div>
  );
};

const DescriptionContent = (props: { name: SettlementTemplateEmailName }) => {
  switch (props.name) {
    case 'AwaitingClientReview':
    case 'DeclinedByCounterparty':
    case 'AcceptedByCounterparty':
    case 'SettlementExecuted':
    case 'ClientAccountCreation':
      return (
        <>
          This email is sent to the <strong>"Client"</strong> by default. If needed,
          you can select additional recipients below. They will be added as "BCC" to
          the email.
        </>
      );
    case 'AwaitingCounterpartyReview':
    case 'AwaitingCounterpartyReviewReminder':
      return (
        <>
          This email is sent to the <strong>"Counterparty"</strong> by default. If
          needed, you can select additional recipients below. They will be added as
          "BCC" to the email.
        </>
      );
  }

  //!!! if you see error here - some case is missed in the Switch operator!!!
  assertSwitchValueNotEmpty(props.name);
};
